<template>
	<div class="modal fade" id="modal-image" tabindex="-1" role="dialog">
		<div class="modal-dialog modal-lg" role="document">
			<div class="modal-content">

				<div class="modal-header">
					<button type="button" class="close" data-dismiss="modal">&times;</button>
				</div>

				<div class="modal-body">
					<img :src="imagem">
				</div>

				<div v-if="inputable" class="modal-footer">
					<button class="btn btn-info btn-sm" onclick="$('#files').trigger('click')">Procurar</button>
					<button class="btn btn-success btn-sm" @click="save" data-dismiss="modal">Salvar</button>

					<input type="file" @change="load_img" id="files" class="hidden">
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	export default {
		name: "modal-image",
		props: ['img', 'inputable', 'input'],

		data() { return {
			inputed: false,
			base64String: null
		}},

		computed: {
			imagem() { return ( this.base64String ) ? this.base64String : this.img }
		},

		methods: {
			open_input() {
				$('#files').click()
			},

			save() {
				this.$emit('change', { img: this.base64String, input: this.input })
			},

			load_img(event) {
				const f = event.target.files[0]
				const reader = new FileReader()

				reader.onload = ( theFile => {
					return e => {
						const binaryData   = e.target.result
						const base64String = window.btoa(binaryData)

						this.base64String = `data:${f.type};base64,${base64String}`
						this.inputed = true
					}
				})(f)

				reader.readAsBinaryString(f)
			},

			clear() {
				this.base64String = null
				this.inputed = false
			}
		}
	}
</script>

<style scoped>
	#modal-image img {
		width: 100%;
	}
</style>
